import { FinLookup, FinRefundLookup, FinServResponse, RefundDocument, RefundRequestModal, ResponseObj } from "./entities";
import { LocaleUtil, StringUtil } from "@eres/core";
import { ErrorContainer } from "@eres/forms";
import Strings from "@my-dld/assets/strings";
import I8N from "@eres/core/dist/I8N";
import * as FinanceDepApi from "./api";
import { TabuRequestApi } from "@10x/tabu-mobile-api";

export function validateFinDepApi( response: ResponseObj ): Promise<FinServResponse> {
	if ( response.Code === "0" ) {
		if ( response.Response ) {
			return Promise.resolve( response.Response );
		}
		return Promise.reject( "Empty response from Server" );
	} else {
		if ( response.Response ) {
			let resp = response.Response;
			if ( resp.ValidationErrors && resp.ValidationErrors.length > 0 ) {
				let errorMsg = "";
				for ( let error of resp.ValidationErrors ) {
					errorMsg = errorMsg + "\n" + LocaleUtil.getLocalValue( { en: error.ErrorMessage, ar: error.ErrorMessageAr } );
				}
				return Promise.reject( errorMsg + "\n" );
			} else {
				return Promise.reject( "Error " + response.Code );
			}
		} else {
			return Promise.reject( "Empty response from Server" );
		}
	}
}

export function validateEmail( errorViews: ErrorContainer,
                               state: any,
                               key: string = "email" ): boolean {
	let isValid = true;
	let email = state[ key ];
	if ( !StringUtil.isEmailAddress( email ) ) {
		isValid = false;
		errorViews[ key ] = Strings.invalid_email;
	}
	return isValid;
}

export function sortCertificateTypes( certificates: FinLookup[] ): FinLookup[] {
	return certificates.sort( ( a, b ) => {
		let locale = I8N.locale();
		return locale === "ar" ? a.NameAr.localeCompare( b.NameAr ) : a.NameEn.localeCompare( b.NameEn );
	} );
}

export function statusToColor( lookup: FinRefundLookup ): string {
	let val = "";
	switch ( lookup.identity ) {
		case 1:
			val = "status-waitingConfirmation";
			break;
		case 2:
			val = "status-financeReject";
			break;
		case 3:
			val = "status-waitingAuditing";
			break;
		case 4:
			val = "status-auditingreject";
			break;
		case 5:
			val = "status-financeMinistrywait";
			break;
		case 6:
			val = "status-financeministryRej";
			break;
		case 7:
			val = "status-completed";
			break;
		default:
			val = "status-waitingConfirmation";
	}
	return val;
}

function uploadFinDepDocuments( req: RefundRequestModal | any ): Promise<RefundRequestModal> {
	let request: RefundRequestModal | any = req;
	let docs: any[] = req.docs! as any[];
	const uploadPromises: Promise<any>[] = [];
	if ( docs ) {
		for ( let doc of docs ) {
			let pages: any[] = doc.docs;
			if ( pages && pages.length > 0 ) {
				for ( let page of pages ) {
					if ( page.remoteId == undefined ) {
						page.Identity = 0;
						page.DocumentId = doc.DocumentId;
						if ( page.localData ) {
							const localData = page.localData;
							const extData = localData.split( ";" )[ 0 ];
							const type = extData.includes( "image" ) ? "jpg" : "pdf";
							let encoded = localData.replace( /^data:(.*;base64,)?/, "" );
							if ( ( encoded.length % 4 ) > 0 ) {
								encoded += "=".repeat( 4 - ( encoded.length % 4 ) );
							}
							uploadPromises.push( TabuRequestApi.uploadTabuDocument( encoded, type ).then( ( response ) => {
								return {
									...response.Response,
									DocumentId: page.DocumentId,
								};
							} ) );
						}
					}
				}
			}
		}
	}
	return Promise.all( uploadPromises ).then( px => {
		if ( docs ) {
			let np: RefundDocument[] = [];
			for ( let p of docs ) {
				let s = px.filter( value => value.DocumentId === p.DocumentId );
				let m: any[] = [];
				for ( let x of s ) {
					m.push( x.DocumentPath );
				}
				p.DocumentPath = m;
				np.push( { DocumentPath: p.DocumentPath, DocumentId: p.DocumentId } );
			}
			request.Documents = np;
		}
		return Promise.resolve( request );
	} );
	return Promise.resolve( request );
}

function makeRequest( req: RefundRequestModal ): Promise<RefundRequestModal> {
	let request: RefundRequestModal | any = req as any;
	request.docs = undefined;
	request.errorViews = undefined;
	request.errorDocs = undefined;
	request.isLoading = undefined;
	return Promise.resolve( request );
}

export function submitRefundRequestCall( req: RefundRequestModal ): Promise<RefundRequestModal> {
	return uploadFinDepDocuments( req ).then( makeRequest ).then( p => {
		return FinanceDepApi.submitRefundRequest( p ).then( resp => {
			return {
				...resp,
				...p,
			};
		} );
	} );
}
